import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import ProtectedAdminRoute from "../components/protectedAdminRoute/protectedAdminRoute";
import { BusniessOfficeNotesContextProvider } from "../context/busniessOfficeNotesContext";
import { InitialDataOfSingleMedicalOrderProvider } from "../context/initialDataOfSingleMedicalOrder";
import { PharmaFormFieldsProvider } from "../context/pharmaFormFieldsContext";
import Analytics from "../pages/analytics/analytics";
import Claims from "../pages/claims/claims";
import ClientConfiguration from "../pages/clientConfiguration/clientConfiguration";
import Configurations from "../pages/configurations/configurations";
import DocumentsToAttach from "../pages/configurations/pages/documentsConfiguration/documentsToAttach";
import EmailPasswordConfiguration from "../pages/configurations/pages/emailPasswordConfiguration/emailPasswordConfiguration";
import FormConfig from "../pages/configurations/pages/formsConfiguration/formConfig";
import FormConfigurationLayout from "../pages/configurations/pages/formsConfiguration/formConfigurationLayout";
import SingleFormConfiguration from "../pages/configurations/pages/formsConfiguration/singleFormConfiguration/singleFormConfiguration";
import HealthFacilityConfiguration from "../pages/configurations/pages/healthFacilityConfiguration/healthFacilityConfiguration";
import MedicineNameConfiguration from "../pages/configurations/pages/medicineNameConfiguration/medicineNameConfiguration";
import NarAgentGridLayout from "../pages/configurations/pages/narAgentGrid/narAgentGridLayout";
import NarConfigurationLayout from "../pages/configurations/pages/narConfiguration/narConfigurationLayout";
import PaFormConfiguration from "../pages/configurations/pages/paFormConfiguration/paFormConfiguration";
import ClinicalQuestionnaire from "../pages/configurations/pages/pharmaPaConfiguration/pages/clinicalQuestionnaire/clinicalQuestionnaire";
import DrugsConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/drugConfig/drugsConfig";
import PayerConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/payerConfiguration/payerConfiuratiom";
import PbmConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/pbmConfiguration/pbmConfiguration";
import ProviderList from "../pages/configurations/pages/pharmaPaConfiguration/pages/providerList/providerList";
import SendToPlanConfig from "../pages/configurations/pages/pharmaPaConfiguration/pages/sendToPlanConfig/sendToPlanConfig";
import PharmaPaConfigurationLayout from "../pages/configurations/pages/pharmaPaConfiguration/pharmaPaConfigurationLayout";
import PrescriptionParsingConfiguration from "../pages/configurations/pages/prescriptionParsingConfiguration/prescriptionParsingConfiguration";
import RpaConfiguration from "../pages/configurations/pages/rpaConfiguration/rpaConfiguration";
import CoverageInfo from "../pages/coverageInfo/coverageInfo";
import CredentialsConfig from "../pages/credentialsConfigration/credentialsConfig";
import DraftSubmission from "../pages/draftSubsmission/draftSubmission";
import EligibilityCheck from "../pages/eligibilityCheck/eligibilityCheck";
import FaxFormQuestionnaireLayout from "../pages/faxFormQuestionnaire/faxFormQuestionnaireLayout";
import FinalDocuments from "../pages/finalDocuments/finalDocuments";
import MedicalNecessityReview from "../pages/medicalNecessityReview/medicalNecessityReview";
import MedicalPaFormLayout from "../pages/medicalPaForm/medicalPaFormLayout";
import MedicalPaLoaderScreen from "../pages/medicalPaLoaderScreen/medicalPaLoaderScreen";
import PatientComponent from "../pages/patients/patientComponent";
import PatientTable from "../pages/patients/patientTable/patientTable";
import SinglePatientComponent from "../pages/patients/single-patient/singlePatient";
import ProcedurePaFormLayout from "../pages/procedurePaForm/ProcedurePaFormLayout";
import ProcedureQuestionaireLayout from "../pages/procedureQuestionaire/procedureQuestionaireLayout";
import Members from "../pages/settings/members/members";
import Profile from "../pages/settings/profile/profile";
import Security from "../pages/settings/security/security";
import Settings from "../pages/settings/settings";
import Support from "../pages/settings/support/support";
import BusniessOffice from "../pages/singleOrderLayout/components/busniessOffice/busniessOffice";
import SingleOrderLayout from "../pages/singleOrderLayout/singleOrderLayout";
import SubmissionStatus from "../pages/submissionStatus/submissionStatus";
import FinalWorklist from "../pages/worklists/finalWorklist/finalWorklist";
import FinalWorklistUpload from "../pages/worklists/finalWorklistUpload/finalWorklistUpload";
import GenericAuthStatusOrders from "../pages/worklists/genericAuthStatusLayout/genericAuthStatusOrders";
import MedicalPaOrdersAlgolia from "../pages/worklists/medicalPaOrdersAlgolia/medicalPaOrders";
import MyPaOrders from "../pages/worklists/myPaOrders/myPaOrders";
import AuthLetters from "../pages/worklists/singleOrder/authLetters/authLetters";
import CptCodes from "../pages/worklists/singleOrder/cptCodes/cptCodes";
import Documents from "../pages/worklists/singleOrder/documents/documents";
import TreatmentPlan from "../pages/worklists/singleOrder/treatmentPlan/treatmentPlan";
import VisitData from "../pages/worklists/singleOrder/visitData/visitData";
import Worklists from "../pages/worklists/worklists";

export const PaRouteConfig = [
  { index: true, element: <Worklists /> },
  {
    path: "worklists",
    element: <Worklists />,
    children: [
      { index: true, element: <Navigate to="medical-pa-orders" replace /> },
      { path: "medical-pa-orders", element: <MedicalPaOrdersAlgolia /> },
      { path: "my-pa-orders", element: <MyPaOrders /> },
      { path: "final-worklist", element: <FinalWorklist /> },
      { path: "final-worklist-upload", element: <FinalWorklistUpload /> },
      { path: ":tabId", element: <GenericAuthStatusOrders /> },
      {
        path: "singleOrder/:orderId?",
        element: (
          <BusniessOfficeNotesContextProvider>
            <InitialDataOfSingleMedicalOrderProvider>
              <SingleOrderLayout />
            </InitialDataOfSingleMedicalOrderProvider>
          </BusniessOfficeNotesContextProvider>
        ),
        children: [
          { index: true, element: <Navigate to="cptCodes" replace /> },
          { path: "cptCodes", element: <CptCodes /> },
          { path: "comments", element: <BusniessOffice /> },
          { path: "treatmentPlan", element: <TreatmentPlan /> },
          { path: "visitData", element: <VisitData /> },
          { path: "documents", element: <Documents /> },
          { path: "authLetters", element: <AuthLetters /> },
        ],
      },

      {
        path: "medical-necessity-review/:orderId",
        element: (
          <BusniessOfficeNotesContextProvider>
            <InitialDataOfSingleMedicalOrderProvider>
              <MedicalNecessityReview />
            </InitialDataOfSingleMedicalOrderProvider>
          </BusniessOfficeNotesContextProvider>
        ),
      },

      {
        path: "evbv/:id?",
        element: (
          <BusniessOfficeNotesContextProvider>
            <InitialDataOfSingleMedicalOrderProvider>
              <CoverageInfo />
            </InitialDataOfSingleMedicalOrderProvider>
          </BusniessOfficeNotesContextProvider>
        ),
      },
      {
        path: "final-document/:id?",
        element: <FinalDocuments />,
      },
      {
        path: "procedure-pa-form/:id?",
        element: <ProcedurePaFormLayout />,
      },
      {
        path: "submission-status/:id",
        element: <SubmissionStatus />,
      },
      {
        path: "procedure-questionaire/:id",
        element: <ProcedureQuestionaireLayout />,
      },
      {
        path: "fax-form-questionnaire/:id",
        element: <FaxFormQuestionnaireLayout />,
      },
      {
        path: "medical-pa-form/:id",
        element: (
          <PharmaFormFieldsProvider>
            <MedicalPaFormLayout />
          </PharmaFormFieldsProvider>
        ),
      },
      {
        path: "medical-pa-loader-screen/:id",
        element: <MedicalPaLoaderScreen />,
      },
      {
        path: "draft-submission/:id",
        element: <DraftSubmission />,
      },
    ],
  },
  {
    path: "patients",
    element: <PatientComponent />,
    children: [
      { index: true, element: <PatientTable /> },
      {
        path: "singlePatient/:patientId?",
        element: <SinglePatientComponent />,
      },
    ],
  },
  {
    path: "eligibilty-check",
    element: <EligibilityCheck />,
  },
  {
    path: "claims-check",
    element: <Claims />,
  },
  {
    path: "analytics",
    element: <Analytics />,
  },

  {
    path: "configurations",
    element: (
      <ProtectedAdminRoute>
        <Configurations />
      </ProtectedAdminRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="documents-configuration" replace />,
      },
      { path: "documents-configuration", element: <DocumentsToAttach /> },
      { path: "rpa-configuration", element: <RpaConfiguration /> },
      {
        path: "form-configuration",
        element: <FormConfigurationLayout />,
        children: [
          { index: true, element: <Navigate to="form-config" replace /> },
          { path: "form-config", element: <FormConfig /> },
          {
            path: "form-config/:id",
            element: <SingleFormConfiguration />,
          },
        ],
      },
      {
        path: "pa-form-configuration",
        element: <PaFormConfiguration />,
      },
      {
        path: "medicine-name-configuration",
        element: <MedicineNameConfiguration />,
      },
      {
        path: "prescription-parsing-configuration",
        element: <PrescriptionParsingConfiguration />,
      },
      {
        path: "pharma-pa-configuration",
        element: <PharmaPaConfigurationLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="send-to-plan-config" replace />,
          },
          { path: "send-to-plan-config", element: <SendToPlanConfig /> },
          { path: "pbm-configurations", element: <PbmConfiguration /> },
          { path: "drugs-configuration", element: <DrugsConfiguration /> },
          { path: "clinical-questionaire", element: <ClinicalQuestionnaire /> },
        ],
      },
      { path: "credentials-configuration", element: <CredentialsConfig /> },
      { path: "client-configuration", element: <ClientConfiguration /> },
      { path: "provider-list", element: <ProviderList /> },
      { path: "payer-config", element: <PayerConfiguration /> },
      { path: "nar-agent-grid", element: <NarAgentGridLayout /> },
      { path: "nar-configuration", element: <NarConfigurationLayout /> },
      {
        path: "health-facility",
        element: <HealthFacilityConfiguration />,
      },
    ],
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      { index: true, element: <Navigate to="profile" replace /> },
      { path: "profile", element: <Profile /> },
      { path: "security", element: <Security /> },
      { path: "members", element: <Members /> },
      { path: "support", element: <Support /> },
    ],
  },
  {
    path: "configurations",
    element: (
      <ProtectedAdminRoute>
        <Configurations />
      </ProtectedAdminRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="documents-configuration" replace />,
      },
      { path: "documents-configuration", element: <DocumentsToAttach /> },
      {
        path: "form-configuration",
        element: <FormConfigurationLayout />,
        children: [
          { index: true, element: <Navigate to="form-config" replace /> },
          { path: "form-config", element: <FormConfig /> },
          {
            path: "form-config/:id",
            element: <SingleFormConfiguration />,
          },
        ],
      },
      {
        path: "pa-form-configuration",
        element: <PaFormConfiguration />,
      },
      {
        path: "medicine-name-configuration",
        element: <MedicineNameConfiguration />,
      },
      {
        path: "prescription-parsing-configuration",
        element: <PrescriptionParsingConfiguration />,
      },
      {
        path: "pharma-pa-configuration",
        element: <PharmaPaConfigurationLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="send-to-plan-config" replace />,
          },
          { path: "send-to-plan-config", element: <SendToPlanConfig /> },
          { path: "pbm-configurations", element: <PbmConfiguration /> },
        ],
      },
      {
        path: "health-facility",
        element: <HealthFacilityConfiguration />,
      },
      {
        path: "email-password-configuration",
        element: <EmailPasswordConfiguration />,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
];
